import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "validation",
  standalone: true,
  templateUrl: "validation.component.html",
  styleUrls: ["validation.component.scss"],
  imports: [CommonModule],
})
export class ValidationComponent {
  @Input() ValidationList = [];
}
